import styled from 'styled-components';

const Espaco = styled.div`
  margin-top: ${(props) => props.size};
`;

export default Espaco;
